module.exports = __webpack_public_path__ + "img/192x192.d14c5398.png";